import {
  MemoizedSelector,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { BaseTag, TagCategory } from '@sleipai/sleip-models';
import { State, tagFeatureKey } from '../reducers/tag.reducer';

export const selectTagState = createFeatureSelector<State>(tagFeatureKey);

export const selectIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectTagState, (state) => state.loading);

export const selectIsLoaded: MemoizedSelector<object, boolean> =
  createSelector(selectTagState, (state) => state.loaded);

export const selectError: MemoizedSelector<object, string | null> =
  createSelector(selectTagState, (state) => state.error);

export const selectTags: MemoizedSelector<
  object,
  { [category: string]: { [id: string]: BaseTag } }
> = createSelector(selectTagState, (state) => state.tags);

export const selectTag = <T extends BaseTag = BaseTag>(
  category: TagCategory | string,
  id: string
) =>
  createSelector(
    selectTags,
    (tags) => (tags?.[category]?.[id] as T) ?? null
  );

export const selectTagsByCategory = <T extends BaseTag = BaseTag>(
  category: TagCategory | string
) =>
  createSelector(selectTags, (tags) => {
    const categoryTags = tags?.[category];
    return categoryTags ? (Object.values(categoryTags) as T[]) : [];
  });